const trips = {
  trips: 'Fahrten',

  stopTypes: {
    charging: '',
    cluster: '(Clusterzentrum)',
  },
  statuses: {
    new: 'Neu',
    in_route: 'Unterwegs',
    sent: 'Gesendet',
    approved: 'Genehmigt',
    done: 'Erledigt',
    canceled: 'Storniert',
  },
  driverActions: {
    more: 'Mehr',
    send: 'Schicken',
    call: 'Anruf',
    note: 'Notiz',
  },
  moreActions: {
    actions: 'Mehr',
    sendTrip: {
      title: 'Fahrt senden',
      body: 'Sie sind dabei, {{tripsCount}} Fahrten zu senden.',
    },
    delete: {
      title: 'Löschen',
      body: 'Sie sind dabei, {{tripsCount}} Fahrten zu löschen.',
    },
    addNote: {
      title: 'Notiz hinzufügen',
      body: 'Sie sind dabei, eine Notiz zu {{tripsCount}} Fahrten hinzuzufügen.',
    },
    showOnMap: 'Auf Karte anzeigen',
    sendMessage: {
      title: 'Nachricht senden',
      body: 'Sie sind dabei, eine Nachricht an {{tripsCount}}-Fahrer zu senden.',
    },
    merge: {
      title: 'Fahrten zusammenführen',
      body: 'Sie sind dabei, {{tripsCount}} Fahrten zusammenzuführen.',
    },
    cancelTrip: {
      title: 'Fahrt stornieren',
      body: 'Sie sind dabei, {{tripsCount}} Fahrten zu stornieren.',
    },
    export: 'Exportieren',
    tripReports: 'Fahrtberichte',
    clearAssinment: {
      title: 'Zuordnung löschen',
      body: 'Sie sind dabei, die Zuweisung für {{tripsCount}} Fahrten zu löschen.',
      confirmButton: 'Bestätigen',
      checkBoxSkipManuallyAssigned: 'Manuelle Zuweisungen in dieser Schnittstelle überspringen',
    },
    clearBlacklistedDrivers: {
      title: 'Gesperrte Fahrer entfernen?',
      body: 'Dadurch werden etwaige gesperrte Fahrer aus den ausgewählten Fahrten und den zugehörigen Reservierungen entfernt - bestehende Fahrerzuweisungen werden nicht verändert.',
      toastSuccess: 'Gesperrte Fahrer erfolgreich entfernt.',
    },
    exportToKml: {
      title: 'KMLs exportieren',
      body: 'Sie sind dabei, KML-Dateien für {{tripsCount}} Fahrten zu exportieren.',
    },
    exportTripDirections: {
      title: 'Wegbeschreibung exportieren',
      body: 'Sie sind dabei, Excel-Dateien für {{tripsCount}} Fahrten zu exportieren.',
    },
    exportToOptibus: {
      body: 'Wählen Sie ein Optibus-Projekt aus, in das die Fahrten exportiert werden sollen:',
    },
  },
  tripInfo: {
    title: 'Trip  ',
    formTabs: {
      detailsTab: 'Details',
      historyTab: 'Geschichte',
      assignInsightsTab: 'Erkenntnisse zuweisen',
      analysis: 'Analyse',
      feedback: 'Feedback',
    },
    driverActions: {
      note: 'Notiz',
      call: 'Anruf',
      send: 'Schicken',
      more: 'Mehr',
    },
    toast: {
      assignment: 'Fahrt erfolgreich zugewiesen',
      toastSomethingWasWrong: 'Irgendetwas stimmte nicht',
      toastActionEndTrip: 'Fahrtende möglich, wenn alle Fahrgäste ausgestiegen sind',
    },
    selectDriver: 'Fahrer auswählen',
    selectVehicle: 'Fahrzeug auswählen',
    bookingDetails: {
      title: 'Buchungsdetails',
    },
    status: 'Status',
    headerBreakDown: 'Fahrtaufschlüsselung',
    driverNotAssigned: 'Fahrer nicht zugewiesen',
    vehicleNotAssigned: 'Fahrzeug nicht zugewiesen',
    noDriver: 'Kein Fahrer',
    noCar: 'Kein Fahrzeug',
    noService: 'Kein Dienst',
    seats: 'Sitzplätze',
    originalStation: 'Original Station: ',
    newStation: 'New Station: ',
    moveStopHeader: 'Sie sind dabei, einen Zwischenstopp in der Fahrt einzulegen: {{ tripId }}',
    date: 'Datum',
    pickupTime: 'Abholzeit',
    eta: 'Nächste Haltestelle voraussichtliche Ankunftszeit',
    passengers: 'Fahrgäste',
    stops: 'Haltestellen',
    distance: 'Distanz',
    miles: 'ml',
    kilometers: 'km',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
    map: {
      switchRoute: {
        toasts: {
          success: 'Route erfolgreich umgestellt',
          failure: 'Beim Umschalten der Route ist ein Fehler aufgetreten',
        },
      },
      operators: {
        fetchError: 'Operatoren können nicht abgerufen werden',
        placeholder: 'Betreiber',
        submit: {
          toasts: {
            success: 'Betreiber erfolgreich aktualisiert',
            error: 'Betreiber können nicht aktualisiert werden',
          },
        },
      },
      stopClusterDistance: ' ({{distance}}m to cluster)',
    },
    modalEndTrip: {
      body: 'Bitte markieren Sie alle Fahrgäste als abgesetzt',
      header: 'Warnung!',
    },
    tripActions: {
      tripBreakdown: 'Fahrtaufschlüsselung',
      note: 'Hinweis hinzufügen',
      history: 'Geschichte',
      msg: 'Senden Sie dem Fahrer eine Nachricht',
      moveToCustomRulesLabel: 'Benutzerdefinierte Regel erstellen',
      start: {
        name: 'Fahrt beginnen',
        title: 'Aktion verfügbar für Status "Genehmigt"',
      },
      end: {
        name: 'Fahrt beenden',
        title: 'Fahrtende möglich, wenn alle Fahrgäste ausgestiegen sind',
      },
      cancel: 'Fahrt stornieren',
      breakdown: 'Fahrtaufschlüsselung',
    },
    stopActions: {
      queue: 'Zur Warteschlange hinzufügen',
    },
    passengerActions: {
      queue: 'Zur Warteschlange hinzufügen',
    },
    assignLog: {
      button: 'Informationen zuweisen',
      closeButton: 'Protokoll zuweisen',
      table: {
        headers: {
          driver: 'Fahrer',
          vehicle: 'Fahrzeug',
          score: 'Punktzahl',
          flag: 'Flagge',
          minutes: 'Minuten',
          radius: 'Radius',
          seatCount: 'Anzahl der Sitzplätze',
          totalTrips: 'Fahrten insgesamt',
          totalPrice: 'Gesamtpreis',
        },
      },
    },
    analysis: {
      header: 'Weitere Details zu manuellen Aktionen finden Sie auf der Registerkarte Fahrt-/Buchungsverlauf',
      table: {
        headers: {
          name: 'Name',
          type: 'Typ',
          description: 'Beschreibung',
          conflict: 'Konflikt',
          item1: 'Punkt 1',
          item2: 'Punkt 2',
          origin: 'Herkunft',
          source: 'Quelle',
        },
      },
    },
    breakdown: {
      table: {
        headers: {
          id: 'Ausweis',
          planned: 'Geplante Zeit',
          date: 'Gewünschte Zeit',
          passenger: 'Fahrgast',
          type: 'Typ',
          from: 'Von',
          to: 'Bis',
          vin: 'Fahrgestellnummer',
          make: 'Machen',
          model: 'Modell',
          year: 'Jahr',
          weight: 'Gewicht',
          height: 'Höhe',
          width: 'Breite',
          length: 'Länge',
          price: 'Preis',
        },
      },
    },
    tripsInfoPlans: {
      toastStatusChanged: 'Status geändert',
      toastStopRemoved: 'Stopp entfernt',
      toastTripRemoved: '[Trips] Erfolgreich entfernt',
      toastTripRemoveError: '[Trips] Konnte nicht entfernt werden',
      toastClearSuccess: '[Trips] Fahrer und Fahrzeuge wurden erfolgreich gelöscht',
      toastClearError: '[Trips] Fahrer und Fahrzeuge wurden erfolgreich gelöscht',
      toastTripCanceled: '[Trips] Erfolgreich storniert',
      toastTripCanceledError: '[Trips] Konnte nicht storniert werden',
      toastJobRemoved: 'Reservierung entfernt',
      toastJobCanceld: 'Die Neureservierung wurde erfolgreich storniert',
      toastSomethingWasWrong: 'Irgendetwas stimmte nicht',
      toastMergeSuccess: 'Fahrten wurden erfolgreich zusammengeführt',
      toastMergeManyLockedAssignments:
        'Fahrten können nicht zusammengeführt werden, da mehrere unterschiedliche gesperrte Zuweisungen vorhanden sind',
      toastMergeError: 'Eine der Fahrten steht nicht zum Zusammenführen zur Verfügung',
      btnRemoveStop: 'Entfernen',
      reservationActions: {
        btnPickUp: {
          name: 'Abgeholt',
          title: 'Nur für den Status in der Route verfügbar',
        },
        btnDroppoff: {
          name: 'Abgesetzt',
          title: 'Nur für den Status in der Route verfügbar',
        },
        btnNoShow: {
          name: 'Nichterscheinen',
          title: 'Nur für den Status in der Route verfügbar',
        },
        btnCancel: 'Reservierung stornieren',
        btnRemove: 'Von der Fahrt entfernen',
      },
    },
    events: {
      chargingStationAdded: 'Ladestation hinzugefügt',
    },
    moveReservation: {
      successToast: 'Haltestellen erfolgreich neu sortiert',
      errorToast: 'Die Reservierung konnte nicht verschoben werden',
    },
    moveStops: {
      successToast: 'Reservierung erfolgreich verschoben',
      errorToast: 'Neuanordnung der Haltestellen fehlgeschlagen',
    },
  },
  edit: {
    applyingEditChanges: 'Applying changes',
    progress: {
      toastSuccess: 'Waypoints saved',
      toastError: 'Failed to apply waypoints',
    },
    unsaved: {
      header: 'Nicht gespeicherte Änderungen',
      body: 'You have unsaved changes. What would you like to do?',
      confirm: 'Discard changes',
      cancel: 'Keep Changes',
    },
  },

  table: {
    floatingActions: {
      tooltips: {
        deleteNotNew: 'Mindestens eine Fahrt hat nicht den Status "Neu"',
        noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
        accept: 'Diese Aktion ist nur für Fahrten mit dem Status "Akzeptieren" oder "Ablehnen" verfügbar.',
        decline: 'Diese Aktion ist nur für Fahrten mit dem Status "Akzeptieren" oder "Ablehnen" verfügbar.',
      },
      assign: 'Zuordnen',
      send: 'Schicken',
      cancel: 'Stornieren',
      delete: 'Löschen',
      export: 'Exportieren',
      merge: 'Zusammenlegen',
      sendMessage: 'Nachricht senden',
      tripReport: 'Fahrtbericht',
      showOnMap: 'Auf Karte anzeigen',
      addNote: 'Notiz hinzufügen',
      exportToKml: 'Exportieren in KML',
      exportTripDirections: 'Wegbeschreibung exportieren',
      exportToOptibusPlanning: 'Zur Planung exportieren',
      exportToOptibusScheduling: 'Zur Terminplanung exportieren',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
    },
    filters: {
      status: 'Status',
      profile: 'Profil',
      attributes: 'Eigenschaften',
      supplier: 'Anbieter',
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
      from: 'Von',
      to: 'Bis',
      locations: 'Standardstandorte',
      airportLocations: 'Flughafenstandorte',
      flightNumber: 'Flugnummer',
      airline: 'Fluggesellschaft',
      flightStatus: 'Flugstatus',
      productionId: 'Produktions-ID',
      drivers: {
        onlyWithout: 'Nicht zugewiesene Fahrten',
        onlyWith: 'Zugewiesene Fahrten',
        all: 'Assigned & Unassigned ',
      },
      vehicles: {
        onlyWithout: 'Fahrzeug nicht zugewiesen',
        onlyWith: 'Zugewiesenes Fahrzeug',
        all: 'Zugewiesen und nicht zugewiesen',
      },
      indicators: 'Indikatoren',
      areas: 'Zonen',
    },
    buttons: {
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
    },
    statuses: {
      new: 'Neu',
      inRoute: 'Unterwegs',
      sent: 'Gesendet',
      approved: 'Genehmigt',
      pickingUp: 'Abholung',
      done: 'Erledigt',
      canceled: 'Storniert',
    },
    indicators: {
      sharedTrip: 'Gemeinsame Fahrt',
      merged: 'Zusammengeführt',
      waitAndReturn: 'Warten & Zurückkehren',
      manuallyAssigned: 'Manuell zugewiesen',
      roundTrip: 'Zweiwege',
      consistentPassengerRouting: 'Einheitliche Fahrgastführung',
      manualDispatched: 'Manuell disponiert',
      error: 'Untersuchung',
    },
    headers: {
      id: 'Ausweis',
      indicators: 'Indikatoren',
      status: 'Status',
      date: 'Datum',
      from: 'Von',
      to: 'Bis',
      seats: 'Sitzplätze',
      passenger: 'Fahrgast',
      profile: 'Profil',
      stops: 'Haltestellen',
      distance: 'Distanz',
      duration: 'Dauer',
      service: 'Dienst',
      flightInfo: 'Fluginformationen',
      flightNumber: 'Flugnummer',
      airline: 'Fluggesellschaft',
      scheduledFlightTime: 'Geplante Flugzeit',
      actualFlightTime: 'Tatsächliche Flugzeit',
      flightStatus: 'Flugstatus',
      supplier: 'Anbieter',
      driver: 'Fahrer',
      car: 'Fahrzeug',
      actions: 'Aktionen',
      attr: 'Eigenschaften',
      externalId: 'Externe ID',
      waitUntil: 'Warten Sie, bis',
      line: 'Linie',
      price: 'Preis',
      reservationsExtendUntilDate: 'Warten bis',
      areas: 'Zonen',
    },
    footer: {
      totalSeats: 'Gesamtzahl der Sitzplätze: {{seats}}',
    },
    cells: {
      isTwoWay: {
        toolTip: 'Zweiwege',
      },
      shared: {
        toolTip: 'Gemeinsame Fahrt',
      },
      waitAndReturn: {
        toolTip: 'Warten und zurückkehren',
      },
      merged: {
        toolTip: 'Zusammengeführte Fahrt',
      },
      chargingStops: {
        toolTip: 'Ladestopps',
      },
      manualAssignment: {
        integration: {
          toolTip: 'Manuell zugewiesen ({{reason}})',
        },
        noIntegration: {
          toolTip: 'Manuell zugewiesen',
        },
      },
      bypassed: {
        toolTip: 'Einstellungen durch manuelle Aktion umgangen',
      },
      isManuallyAltered: {
        toolTip: 'Manuell disponiert',
      },
      manualDispatch: {
        and: '&',
        reason: {
          grouped: 'Gruppiert',
          manualRoute: 'Manuelle Route',
          dragAndDrop: 'Drag and Drop',
          manualRouteIntegration: 'Manual Route (Integration)',
        },
      },
      car: {
        none: 'Keine Fahrzeuge',
      },
      driver: {
        none: 'Kein Fahrer',
      },
      supplier: {
        none: 'Kein Anbieter',
      },
      isConsistentPassengerRouting: {
        toolTip: 'Einheitliche Fahrgastführung',
      },
      actions: {
        approve: 'Genehmigen',
        remove: 'Entfernen',
      },
    },
    actions: {
      autoAssign: {
        modal: {
          header: 'Aufgabenzusammenfassung',
          body: {
            trips: {
              total: 'Fahrten insgesamt',
              assigned: 'Gesamt zugewiesen',
              unassigned: 'Nicht zugewiesen',
            },
            drivers: {
              preAssigned: 'Vorab zugewiesen',
              autoAssigned: 'Automatisch zugewiesen',
              total: 'Fahrer insgesamt',
              totalDriversAssigned: 'Gesamt zugewiesen',
              unassigned: 'Nicht zugewiesen',
            },
            vehicles: {
              total: 'Fahrzeuge insgesamt',
              used: 'Gesamt zugewiesen',
            },
            insights: {
              title: 'Zuweisungseinblicke pro Fahrer',
              assignmentTime: 'Zuweisungsbearbeitungszeit',
              avgDistance: 'Durchschnittliche Fahrtdistanzen',
              avgDistanceToPickup: 'Durchschnittliche Leerfahrtstrecke',
              avgDuration: 'Durchschnittliche Fahrtdauer',
              avgDurationToPickup: 'Durchschnittliche Leerfahrtdauer',
              avgPrice: 'Durchschnittspreis',
              waitAvg: 'Durchschnittliche Leerlaufzeit',
            },
          },
        },
        errorModal: {
          header: 'Fehler',
          body: 'Alle ausgewählten Fahrten wurden bereits zugewiesen. Um Fahrer neu zuzuweisen, löschen Sie bitte zunächst die aktuelle Zuweisung.',
        },
      },
      assign: {
        assign: 'Zuordnen',
        clearDriversVehicle: 'Fahrer/Fahrzeuge löschen',
        clearBlacklistedDrivers: 'Gesperrte Fahrer entfernen',
        advancedAssign: 'Erweiterte Zuweisung',
        modalHeader: 'Fahrten zuordnen',
        youAreAboutToAssign: 'Sie sind dabei, {{numberOfTrips}} Fahrten zuzuweisen.',
        assignError: 'Fehler beim Zuweisen von Fahrten',
      },
      merge: {
        errorMessage: 'Es wurde keine zusätzliche Fahrt zum Zusammenführen gefunden',
        shuttle: 'Shuttlefahrten dürfen nicht zusammengelegt werden',
      },
      showOnMap: {
        header: 'Auf Karte anzeigen',
        shuttle: 'Shuttlefahrten dürfen nicht zusammengelegt werden',
      },
      export: {
        optibus: {
          header: 'Projekte',
          placeholder: '',
          export: 'Exportieren',
          success: 'Die ausgewählten Fahrten wurden erfolgreich an das ausgewählte Optibus-Projekt gesendet.',
        },
      },
      cancelReservation: 'Sie sind dabei, diese Reservierung zu stornieren',
      report: {
        header: 'Routenübersicht',
        body: {
          totalTrips: 'Fahrten',
          totalCost: 'Kosten',
          totalPrice: 'Preis',
          totalJobs: 'Reservierungen',
          totalDuration: 'Dauer',
          totalDistance: 'Distanz',
          totalAssigned: 'Zugewiesen',
          totalUnassigned: 'Nicht zugewiesen',
          totalDrivers: 'Fahrer',
          averageJobs: 'Durchschnittliche Reservierungen',
          averageDistance: 'Durchschnittliche Entfernung',
          averageDuration: 'Durchschnittliche Dauer',
        },
      },
    },
  },
};

export default trips;
